import React from 'react';
import { TrendingUp } from 'lucide-react';
import TopTickers from '../ui/TopTickers';
import TickerSearch from '../ui/TickerSearch';
import { PageHeader } from '../ui/PageHeader';

const Market: React.FC = () => {
  return (
    <div className="content">
    <div className="container mx-auto px-4 py-8 max-w-6xl">
        <PageHeader
          title="Top Discussed Tickers"
          subtitle="Last 3 hours • Live sentiment analysis"
          icon={TrendingUp}
        />
        
        {/* Ticker Search Section */}
        <div
          className="top-tickers-search-wrap rounded-2xl p-6 mb-6"
        >
          <div className="mb-4">
            <h2 className="text-xl font-semibold text-brand-gold mb-1">Find Any Ticker</h2>
            <p className="text-sm text-white/60">Search for any ticker to view its sentiment analysis</p>
          </div>
          <TickerSearch />
        </div>
        
        <div className="bg-brand-card rounded-2xl p-6 border border-brand-border shadow">
          <TopTickers />
        </div>
    </div>
    </div>
  );
};

export default Market; 
